import {useSelector} from "react-redux";

export const downloadBlob = (blobData, fileName) => {
  let url = window.URL.createObjectURL(new Blob([blobData]));
  let link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export const generateUrl = (params) => {
  let entity = getEntity(params?.entity_type);
  return (entity && params?.entity_id) ? entity + '/' + params?.entity_id : entity;
}

function getEntity(entity){
  switch (entity) {
    // uncomment when product details page available
    // case (1):
    //   return 'products'
    case (2):
      return 'orders'
    default: return ''
  }
}

export const userCan = (permissions, permission) => {
  if(permissions && !permission){
    return true;
  }
  return permissions?.find(item => item.name.replace(' : ', ' ') === permission) ? true : false
}

export const userCanAny = (permissions, permissionArray) => {
  return permissionArray.some(item => permissions?.find(permission => permission.name.replace(' : ', ' ') === item));
}